// extracted by mini-css-extract-plugin
export default {"primaryCare":"clinicPrimaryCare_primaryCare__0S6Vm"};